import styled, { css } from "vue-styled-components";
import { darken } from "../../utils/colors";

export const AppButtonProps = {
  variant: {
    type: String,
    default: "primary",
    validator: value => ["primary", "light"].includes(value)
  },
  size: {
    type: String,
    default: "md",
    validator: value => ["sm", "md", "lg"].includes(value)
  },
  block: {
    type: Boolean,
    default: false
  },
  outline: {
    type: Boolean,
    default: false
  },
  pill: {
    type: Boolean,
    default: false
  }
};

const variants = {
  primary: ({ colors }) => css`
    color: ${colors.neutral.gray0};
    background-color: ${colors.brand.primary};
    border-color: ${colors.brand.primary};

    &:hover:enabled {
      color: ${colors.neutral.gray0};
      background-color: ${darken(colors.brand.primary, 10)};
      border-color: ${darken(colors.brand.primary, 10)};
    }

    &:focus:enabled,
    &.focus:enabled,
    &:active:enabled,
    &.active:enabled {
      color: ${colors.neutral.gray0};
      background-color: ${darken(colors.brand.primary, 10)};
      border-color: ${darken(colors.brand.primary, 10)};
    }
  `,

  light: ({ colors }) => css`
    color: ${colors.neutral.gray8};
    background-color: ${colors.neutral.gray1};
    border-color: ${colors.neutral.gray1};

    &:hover:enabled {
      color: ${colors.neutral.gray8};
      background-color: ${darken(colors.neutral.gray1, 10)};
      border-color: ${darken(colors.neutral.gray1, 10)};
    }

    &:focus:enabled,
    &.focus:enabled,
    &:active:enabled,
    &.active:enabled {
      color: ${colors.neutral.gray8};
      background-color: ${darken(colors.neutral.gray1, 10)};
      border-color: ${darken(colors.neutral.gray1, 10)};
    }
  `
};

const sizes = {
  sm: ({ font }) => css`
    padding: 8px 16px;
    font-size: ${font.size.sm};
    border-radius: 4px;
  `,
  md: ({ font }) => css`
    padding: 12px 20px;
    font-size: ${font.size.md};
    border-radius: 6px;
  `,
  lg: ({ font }) => css`
    padding: 18px 24px;
    font-size: ${font.size.lg};
    border-radius: 10px;
  `
};

export const SWrapper = styled("button", AppButtonProps)`
  ${({ theme, variant, size, block, outline, pill }) => css`
    display: inline-block;
    font-variant: normal;
    font-style: normal;
    font-weight: ${theme.font.weight.medium};
    font-family: ${theme.font.family.inter};
    white-space: nowrap;
    text-align: center;
    vertical-align: middle;
    border: 1px solid transparent;
    border-radius: 8px;
    transition: all 0.3s ease;
    overflow: hidden;
    outline: none;
    box-shadow: none;

    &:not(:disabled) {
      cursor: pointer;
    }

    ${variant && variants[variant](theme)}
    ${size && sizes[size](theme)}

    ${block &&
      css`
        width: 100%;
      `}

    ${pill &&
      css`
        border-radius: 100px;
      `}

    ${outline &&
      css`
        color: ${theme.colors.brand[variant]};
        background-color: transparent;
        border-color: ${theme.colors.brand[variant]};

        ${variant === "light" &&
          css`
            color: ${theme.colors.neutral.gray8};
            background-color: ${theme.colors.neutral.white};
            border-color: ${theme.colors.neutral.gray3};

            &:hover:enabled,
            &:focus:enabled,
            &:active:enabled {
              background-color: ${theme.colors.neutral.white};
              border-color: ${theme.colors.neutral.gray8};
            }
          `}
      `}


    &:disabled {
      color: ${theme.colors.neutral.white};
      background-color: ${theme.colors.neutral.gray3};
      border-color: ${theme.colors.neutral.gray3};
    }
  `}
`;
